export const usaStateNames = [
  'US-AK', 'US-AL', 'US-AR', 'US-AZ', 'US-CA', 'US-CO', 'US-CT', 'US-DC', 'US-DE', 'US-FL',
  'US-GA', 'US-HI', 'US-IA', 'US-ID', 'US-IL', 'US-IN', 'US-KS', 'US-KY', 'US-LA', 'US-MA',
  'US-MD', 'US-ME', 'US-MI', 'US-MN', 'US-MO', 'US-MS', 'US-MT', 'US-NC', 'US-ND', 'US-NE',
  'US-NH', 'US-NJ', 'US-NM', 'US-NV', 'US-NY', 'US-OH', 'US-OK', 'US-OR', 'US-PA', 'US-PR', 'US-RI',
  'US-SC', 'US-SD', 'US-TN', 'US-TX',  'US-UT', 'US-VA', 'US-VT', 'US-WA', 'US-WI', 'US-WV',
  'US-WY'];

export const canadaStateNames = [ 'CA-AB', 'CA-BC', 'CA-MB', 'CA-NB', 'CA-NF', 'CA-NL', 'CA-NS', 'CA-NT', 'CA-NU', 'CA-ON', 'CA-PE', 'CA-QC', 'CA-SK', 'CA-YT', 'CA-ZZ']

export const mexicoStateNames = [
  'MX-AGS', 'MX-BC', 'MX-BCS', 'MX-CHI', 'MX-CHS', 'MX-CMP', 'MX-COA', 'MX-COL', 'MX-DF',
  'MX-DGO', 'MX-GRO', 'MX-GTO', 'MX-HGO', 'MX-JAL', 'MX-MCH', 'MX-MEX', 'MX-MOR', 'MX-NAY',
  'MX-NL', 'MX-OAX', 'MX-PUE', 'MX-QR', 'MX-QRO', 'MX-SIN', 'MX-SLP', 'MX-SON', 'MX-TAB',
  'MX-TLX', 'MX-TMS', 'MX-VER', 'MX-YUC', 'MX-ZAC',
];
